import { makeAutoObservable } from "mobx";
import { UserStore } from "./UserStore";
import { UIStore } from "./ui/UIStore";

export class RootStore {
	// properties
	private initialaizing = true;

	// composition stores
	userStore: UserStore;
	uiStore: UIStore;

	constructor() {
		this.userStore = new UserStore();
		this.uiStore = new UIStore();
		makeAutoObservable(this);
	}

	// setters
	public setInitializing(isInitialaizing = false) {
		this.initialaizing = isInitialaizing;
	}

	get isInitialaizing() {
		return this.initialaizing;
	}
}
